import type { SVGProps } from 'react';

const SvgHub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1008_31069)">
      <path
        d="M18.025 11.4475H15.5174C15.2789 9.92427 14.0751 8.72079 12.5523 8.48234V5.97475C12.5523 5.6701 12.3045 5.42236 11.9999 5.42236C11.6952 5.42236 11.4475 5.6701 11.4475 5.97475V8.48234C9.92388 8.72079 8.72002 9.92504 8.48196 11.449C8.4777 11.449 8.47344 11.4479 8.46918 11.4479H5.97475C5.6701 11.4479 5.42236 11.6956 5.42236 12.0003C5.42236 12.3049 5.6701 12.5526 5.97475 12.5526H8.46918C8.47344 12.5526 8.4777 12.5515 8.48196 12.5515C8.72002 14.0751 9.92388 15.2793 11.4475 15.5182V18.0258C11.4475 18.3304 11.6952 18.5781 11.9999 18.5781C12.3045 18.5781 12.5523 18.3304 12.5523 18.0258V15.5182C14.0755 15.2797 15.2789 14.0759 15.5174 12.553H18.025C18.3292 12.553 18.5774 12.3053 18.5774 12.0006C18.5774 11.696 18.3292 11.4475 18.025 11.4475Z"
        fill="currentColor"
      />
      <path
        d="M12.0001 4.71945C13.3033 4.71945 14.3598 3.66297 14.3598 2.35973C14.3598 1.05649 13.3033 0 12.0001 0C10.6969 0 9.64038 1.05649 9.64038 2.35973C9.64038 3.66297 10.6969 4.71945 12.0001 4.71945Z"
        fill="currentColor"
      />
      <path
        d="M2.35973 14.3596C3.66297 14.3596 4.71945 13.3031 4.71945 11.9999C4.71945 10.6966 3.66297 9.64014 2.35973 9.64014C1.05649 9.64014 0 10.6966 0 11.9999C0 13.3031 1.05649 14.3596 2.35973 14.3596Z"
        fill="currentColor"
      />
      <path
        d="M11.9999 24.0002C13.3031 24.0002 14.3596 22.9437 14.3596 21.6405C14.3596 20.3372 13.3031 19.2808 11.9999 19.2808C10.6966 19.2808 9.64014 20.3372 9.64014 21.6405C9.64014 22.9437 10.6966 24.0002 11.9999 24.0002Z"
        fill="currentColor"
      />
      <path
        d="M21.6402 14.3596C22.9435 14.3596 24 13.3031 24 11.9999C24 10.6966 22.9435 9.64014 21.6402 9.64014C20.337 9.64014 19.2805 10.6966 19.2805 11.9999C19.2805 13.3031 20.337 14.3596 21.6402 14.3596Z"
        fill="currentColor"
      />
    </g>

    <defs>
      <clipPath id="clip0_1008_31069">
        <rect width="23.9997" height="23.9997" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgHub;
